export default {
  registerCode: (state) => {
    return state.registerCode;
  },

  token: (state) => {
    return state.token;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },

  checkNewRegister: (state) => {
    return state.checkNewRegister;
  },

  forgotCode: (state) => {
    return state.forgotCode;
  },

  profile: (state) => {
    return state.profile;
  },

  companies: (state) => {
    return state.companies;
  },

  company: (state) => {
    return state.company;
  },

  printCompany: (state) => {
    return state.printCompany;
  },

  transactions: (state) => {
    return state.transactions;
  },

  wallet: (state) => {
    return state.wallet;
  },

  paymentGateway: (state) => {
    return state.paymentGateway;
  },

  paymentResult: (state) => {
    return state.paymentResult;
  },

  invoices: (state) => {
    return state.invoices;
  },
  invoiceById: (state) => {
    return state.invoiceById;
  },

  billSubjects: (state) => {
    return state.billSubjects;
  },
  billSubjectOptions: (state) => {
    const list = [];
    state.billSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  billTypes: (state) => {
    return state.billTypes;
  },
  billTypeOptions: (state) => {
    const list = [];
    state.billTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  billPatterns: (state) => {
    return state.billPatterns;
  },
  billPatternOptions: (state) => {
    const list = [];
    state.billPatterns.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  buyerTypeOptions: (state) => {
    const list = [];
    state.buyerTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  flightTypeOptions: (state) => {
    const list = [];
    state.flightTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  clearingMethodOptions: (state) => {
    const list = [];
    state.clearingMethods.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  paymentTypeOptions: (state) => {
    const list = [];
    state.paymentTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  unitMeasurementOptions: (state) => {
    const list = [];
    state.unitMeasurements.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  currencyTypeOptions: (state) => {
    const list = [];
    state.currencyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        iso: item.iso,
        label: item.title + " " + item.description + " (" + item.iso + ")",
      };
      list.push(pushItem);
    }
    return list;
  },

  inquiryInvoiceLogs: (state) => {
    return state.inquiryInvoiceLogs;
  },

  inquiryCheck: (state) => {
    return state.inquiryCheck;
  },

  invoiceFileLink: (state) => {
    return state.invoiceFileLink;
  },

  printAddress: (state) => {
    return state.printAddress;
  },

  taxKeys: (state) => {
    return state.taxKeys;
  },

  taxKeyByNational: (state) => {
    return state.taxKeyByNational;
  },

  publicKeyLink: (state) => {
    return state.publicKeyLink;
  },

  pfxResult: (state) => {
    return state.pfxResult;
  },

  companyFinalPrice: (state) => {
    return state.companyFinalPrice;
  },
};
